export default function Hero() {
  return (
    <section className="relative w-full min-h-[600px] md:min-h-[700px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Soft%20abstract%20flowing%20silk%20fabric%20waves%20in%20warm%20amber%20sage%20and%20cream%20tones%20creating%20elegant%20organic%20shapes%2C%20modern%20minimalist%20art%20composition%2C%20gentle%20gradients%20and%20subtle%20texture%2C%20dreamy%20ethereal%20atmosphere%2C%20high%20end%20editorial%20quality%2C%20sophisticated%20neutral%20color%20palette&width=1800&height=900&seq=hero-bg-v2-main&orientation=landscape"
          alt="Kakobuy Spreadsheet shopping database background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/25 via-black/15 to-black/30"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6">
        <div className="max-w-4xl mx-auto text-center">
          <div className="inline-flex items-center gap-2 px-4 py-1.5 rounded-full bg-white/15 backdrop-blur-sm border border-white/20 mb-6">
            <span className="w-2 h-2 rounded-full bg-green-400 animate-pulse"></span>
            <span className="text-xs md:text-sm text-white/90 font-medium">Updated Weekly · Community Curated · Free Access</span>
          </div>

          <h1 className="font-heading text-3xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6">
            Kakobuy Spreadsheet — The Ultimate Database For<br className="hidden md:block" />
            <span className="text-accent-200">Updated Finds, Products &amp; Shopping Lists</span>
          </h1>

          <p className="text-base md:text-lg text-white/80 max-w-2xl mx-auto mb-8 leading-relaxed">
            Discover thousands of curated Kakobuy Spreadsheet finds, updated product lists, shopping guides, and comparison resources in one powerful platform. Finding the right products has never been easier.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto px-8 py-3.5 bg-primary-500 text-white text-sm font-semibold rounded-full hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer shadow-lg shadow-primary-500/25"
            >
              Explore Kakobuy Sheet
              <i className="ri-arrow-right-up-line ml-2"></i>
            </a>
            <a
              href="https://kaspreadsheet.com"
              target="_blank"
              rel="noopener nofollow"
              className="w-full sm:w-auto px-8 py-3.5 bg-white/15 backdrop-blur-sm border border-white/30 text-white text-sm font-semibold rounded-full hover:bg-white/25 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Buy It Now
              <i className="ri-shopping-bag-line ml-2"></i>
            </a>
          </div>

          <div className="mt-12 flex items-center justify-center gap-8 md:gap-12">
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-bold text-white">14+</p>
              <p className="text-xs md:text-sm text-white/60 mt-1">Categories</p>
            </div>
            <div className="w-px h-10 bg-white/20"></div>
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-bold text-white">10K+</p>
              <p className="text-xs md:text-sm text-white/60 mt-1">Products Listed</p>
            </div>
            <div className="w-px h-10 bg-white/20"></div>
            <div className="text-center">
              <p className="text-2xl md:text-3xl font-bold text-white">Weekly</p>
              <p className="text-xs md:text-sm text-white/60 mt-1">Updates</p>
            </div>
          </div>
        </div>
      </div>

      <div className="absolute bottom-0 left-0 right-0 h-24 bg-gradient-to-t from-background-50 to-transparent"></div>
    </section>
  );
}